import React, { FC } from 'react';
import styled from 'styled-components';
import { ChevronRightIcon } from '../NgIcons';

const StyledButton = styled.button<{ $expanded: boolean }>`
  position: absolute;
  right: -15px;
  top: 120px;
  z-index: 10;
  width: 16px;
  height: 32px;
  border-radius: 0 6px 6px 0;
  background: ${({ theme }) => theme.palette.cardBackground};
  border: 1px solid ${({ theme }) => theme.palette.cardBorder};
  border-left: ${({ theme }) => theme.palette.cardBackground};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: ${({ theme }) => theme.palette.textDimmed};
  box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.06);

  svg {
    width: 12px;
    height: 12px;
    transition: transform 0.2s;
    transform: ${({ $expanded }) => ($expanded ? 'rotate(180deg)' : 'none')};
  }

  &:hover {
    background: ${({ theme }) => theme.palette.hoverBackgroundColor || '#f5f5f5'};
  }
`;

interface NgPanelExpandButtonProps {
  expanded: boolean;
  onClick: () => void;
}

export const NgPanelExpandButton: FC<NgPanelExpandButtonProps> = ({ expanded, onClick }) => (
  <StyledButton
    $expanded={expanded}
    title={expanded ? 'Collapse' : 'Expand'}
    onClick={onClick}
  >
    <ChevronRightIcon />
  </StyledButton>
);
